import { ApplicationLoadingDisplay } from "core/components/ApplicationLoadingDisplay";

export function SignInOIDCPage() {
  return <ApplicationLoadingDisplay />;
}
